<template>
    <div class="px-4">
        <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined ><v-icon>mdi-arrow-left-bold</v-icon> Volver Atras </v-btn>
        <h4 class="text-center">Depositos realizados en la caja</h4>   

        <v-data-table :loading="loading" :headers="headers" :items="desserts" disable-pagination hide-default-footer :items-per-page="5" class="elevation-1">
            <template v-slot:[`item.deleted_at`]="{ item }">
                <p class="red--text"> {{ item.deleted_at }} </p>
            </template>
            <template v-slot:[`item.estado`]="{ item }">
                <p class=""> {{ getEstado(item.estado) }} </p>
            </template>
            <!-- <template v-slot:[`item.sede`]="{ item }">
                <p> {{ item.sede.nombre }} </p>
            </template> -->
            <template v-slot:[`item.sede`]="{ item }">
                <p> {{ item.sede?item.sede.nombre:'' }} </p>
            </template>
            <template v-slot:[`item.sede_caja`]="{ item }">
                <p> {{ item.sede_caja?item.sede_caja.nombre:'' }} </p>
            </template>

            <template v-slot:[`item.opt`]="{ item }">
                <div style="min-width: 150px;">   
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" tile small text color="orange" @click="obtenerDetalles(item.id)"> <v-icon>mdi-eye</v-icon> </v-btn>
                        </template>
                        <span> Ver detalles </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="item.estado==3" v-bind="attrs" v-on="on" tile small text color="green" @click="openDeta(item.id)"> <v-icon>mdi-plus</v-icon> </v-btn>
                        </template>
                        <span> Agregar comprobante </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="item.estado==3 || item.estado==1" v-bind="attrs" v-on="on" tile small text color="blue" @click="verificaropen(item)"> <v-icon>mdi-check</v-icon> </v-btn>
                        </template>
                        <span> Verificar </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }"> 
                            <v-btn  v-bind="attrs" v-on="on" tile small text color="purple" @click="$router.push('/depositostodepos?idcaja='+cajaid+'&depoid='+item.id)"> <v-icon>mdi-file-cloud</v-icon> </v-btn>
                        </template>
                        <span> Depositos del deposito </span>
                    </v-tooltip>
                      
                </div>
            </template>
        </v-data-table> 
        
        <registrarv2 ref="refagregarv2" v-on:success="cargarDatos"/>
        <verdepo ref="refverdepo" />
    </div>
  </template>

<script> 
import registrarv2 from '../cajas/registrarv2.vue'; 
import verdepo from './verdepo.vue'; 
import xaxios from '@/xaxios';

export default {
    components:{ registrarv2,verdepo },
    data () {
        return {
            headers: [ 
                { text: '#', value: 'nro' },
                { text: 'Monto recaudado', value: 'monto_recaudado' },
                { text: 'Monto depositado', value: 'monto_depositado' },
                // { text: 'Origen', value: 'sede' },
                { text: 'Creador', value: 'created_by' },
                { text: 'Registro', value: 'created_at' },
                { text: 'Comprobante', value: 'comprobante' },
                { text: 'Deposito', value: 'fecha_deposito' }, 
                { text: 'Destino', value: 'sede' }, 
                { text: 'Estado', value: 'estado' },
                { text: '', value: 'opt' },
            ],
            desserts: [],
            eliminados: false,
            loading: false,
            cajaid: null,
        }
    }, 
    methods:{
        opennominaciones(){
            this.$router.push('/nominaciones')
        },  
        async cargarDatos(){
            let cajaid = this.$route.query.idcaja; 
            this.loading = true;
            this.desserts = [];
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${cajaid}/cajas`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            window.console.log(res);
            if(res && res.data ) {
                res.data.map((x,i)=>{
                    x,
                    x.nro = i+1
                })
                this.desserts = res.data;
            }
            this.loading = false;
        }, 
        async obtenerDetalles(depoid){  
            this.$refs.refverdepo.openmodal(depoid); 
        },
        openDeta(cajaid){
            this.$refs.refagregarv2.openmodal(cajaid);
        },
        getEstado(est){
            if (est == 1) return 'recaudado';
            else if (est == 2) return 'depositado';
            else if (est == 3) return 'verificado';
            else return '??';
        },
        async verificaropen(item){
            window.console.log('item',item);
            this.$root.$notify.show(`La verificacion lo debe realizar la sede de destino en el menu Depositos Caja`, {color:'green',y: 'left',});
            /*let message = { 
                title: 'Para indicar como verificado, valide esta accion:',
                body: '<br> <b>NOTA:</b> Esta accion es irreversible',
            };
            let options = {
                html: true,
                okText: 'Verificado',
                cancelText: 'Cancelar',
                reverse: true,
                type: 'hard',
                verification: 'verificado',
                verificationHelp: 'Escriba "[+:verification]" para proceder.',
                loader: true,
            };
            let dialogo = await this.$dialog.confirm(message, options).then(d=>d).catch(e=>e);
            if(dialogo){
                // 
                let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${item.id}`; 
                const res = await axios.patch(url).then(x=>x).catch(x=>x);
                window.console.log(res);
                dialogo.close();
                this.cargarDatos();
            }
            window.console.log('dialogo',dialogo)*/
        },
    },
    async mounted(){ 
        this.cajaid = this.$route.query.idcaja; 
        this.cargarDatos();
        
    }
}
</script>